// 国内版本默认配置

/**
 * BASE_API 接口域名
 * BASE_MICRO_APPS 微前端子应用域名
 * AGI_API AGI（pandora）网关域名，通用助手页（/assistant）专用
 */
const config = {
  local: {
    APP_ID: 100360,
    BASE_API: 'powerpro-api-dev.nio.com',
    BASE_MICRO_APPS: 'power-micro-apps-dev.nio.com',
    AGI_API: 'power-agi-dev.nioint.com',
  },
  dev: {
    APP_ID: 100360,
    BASE_API: 'powerpro-api-dev.nio.com',
    BASE_MICRO_APPS: 'power-micro-apps-dev.nio.com',
    AGI_API: 'power-agi-dev.nioint.com',
  },
  test: {
    APP_ID: 100360,
    BASE_API: 'powerpro-api-test.nio.com',
    BASE_MICRO_APPS: 'power-micro-apps-test.nio.com',
    AGI_API: 'power-agi-test.nioint.com',
  },
  stg: {
    APP_ID: 100360,
    BASE_API: 'powerpro-api-stg.nio.com',
    BASE_MICRO_APPS: 'power-micro-apps-stg.nio.com',
    // AGI 公网入口（pe-ingress-world-qc-stg）：pandora 路由已验证（2026-10-27，
    // run_sse 全链路 + Bearer token + CORS 预检均通过）；dev/test 暂无公网域名，保持内网
    AGI_API: 'power-agi-ext-stg.nio.com',
  },
  prod: {
    APP_ID: 100360,
    BASE_API: 'powerpro-api.nio.com',
    BASE_MICRO_APPS: 'power-micro-apps.nio.com',
    AGI_API: 'power-agi-ext.nio.com',
  },
}

module.exports = config
